@if (!isOldIcon) {
  <div [ngClass]="[width, height, 'block']">
    <mat-icon [svgIcon]="iconRaw" [class]="classList" [class.disabled]="disabled"></mat-icon>
  </div>
} @else {
  <span [style.font-size]="fontSize" [style.line-height]="lineHeight" class="mdi {{ iconRaw }} {{ classList }}" [class.disabled]="disabled"></span>
}

